import React, { useEffect, useState } from "react";
import { Form, Input, Space, Select, Button, List } from 'antd';
import FormItem from "components/fields/FormItem";
import { useDispatch, useSelector } from "react-redux";
import { 
	getClientTeamDetails, 
	doClientTeamCreate, 
	doClientTeamUpdate, 
	doClientUserCreate,
	doDeleteSupervisor,
} from "../../../../../redux/client/clientState";
import CrudButtons from "components/button/crudbuttons";
import UnassignButton from "components/button/unassignbutton";
import { requiredField, emailField } from "utils/crudSagaHelper";
import { PlusOutlined, DownOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import { MODULE_CLIENT } from "variables/constants";


const ClientTeamForm = ({
	onCancel, 
	clientId,
	submitLabel,
	...props
 }) => {
	const dispatch = useDispatch();
	const recordData = useSelector((state) => state.client.clientTeamDetails?.data);

	const doCreate = (data) => dispatch(doClientTeamCreate(data));
	const doUpdate = (data) => dispatch(doClientTeamUpdate(data));
	const doUnassign = (data) => dispatch(doDeleteSupervisor(data));


  	const [form] = Form.useForm();
  	const { recordId, mode } = props;
	const [supervisorSelected, setSupervisorSelected] = useState(false);
	const [addUserFilled, setAddUserFilled] = useState(false);
	const [userList, setUserList] = useState([]);
	const [supervisors, setSupervisors] = useState(recordData?.supervisors || []);
	const [addUserOpen, setAddUserOpen] = useState(false);
	const [addUserValidation, setAddUserValidation] = useState(false);

	const toggleAddUser = () => {
		const nextOpen = !addUserOpen;

		if (nextOpen) {
			setAddUserValidation(true);
			setAddUserOpen(true);
			return;
		}

		setAddUserOpen(false);

		setTimeout(() => {
			form.resetFields([
				"ude_first_name",
				"ude_last_name",
				"email",
				"clu_job_title",
			]);

			setAddUserValidation(false);
		}, 200);
	};

	useEffect(() => {
		if (recordData?.userList) {
			setUserList(recordData.userList.map(u => ({ value: u.value, label: u.label })));
		}
	}, [recordData]);

	useEffect(() => {	
		if (recordData) {

			form.resetFields();
			const {client_team:clientTeam, ...rest } = recordData;

			const supervisorIds = recordData?.supervisors?.map(s => s.supervisor?.id ?? s.supervisor_id) || [];

			const initialValues = {
				...rest,
				...clientTeam,
				cte_client_id: clientId,
				supervisors: supervisorIds,
			};
			form.setFieldsValue(initialValues);

			setSupervisorSelected(supervisorIds.length > 0);
		}
	}, [recordData, clientId, form]);

	const handleValuesChange = (changed, allValues) => {
		if (changed.clu_user_id !== undefined) {
			setSupervisorSelected(!!changed.clu_user_id);
		}

		const addUserFields = [
			allValues.ude_first_name,
			allValues.ude_last_name,
			allValues.email,
			allValues.clu_job_title,
		];
		setAddUserFilled(addUserFields.some((v) => !!v !== ""));
	};

	useEffect(() => {
		if (clientId && recordId !== undefined) {
			dispatch(getClientTeamDetails({ 
				clientId, 
				teamId: recordId 
			}));
		}
	}, [clientId, recordId, dispatch]);
   
  	const onSubmit = async (formData) => {
		try {

		const payload = {
			...formData,
			cte_client_id: Number(formData.cte_client_id),
		};

        if (!Array.isArray(payload.supervisors)) {
            payload.supervisors = payload.supervisors ? [payload.supervisors] : [];
        }

		recordData?.cte_id > 0 ? doUpdate(payload) : doCreate(payload);

		} catch (error) {
			console.error("Save failed:", error);
		}
	};

  	return (
		<Form className={mode !== "view" ? "form" : ""}
			layout="vertical"
			form={form}
			onFinish={onSubmit}
			onValuesChange={handleValuesChange}
		>   
			<FormItem
				name="cte_client_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			<FormItem
				name="cte_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			<FormItem
				name="cte_status_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			<div className="grid grid-cols-1 md:grid-cols-3 gap-y-2 gap-x-4 w-full">  		            	            
				<div className="col-span-2">
					<FormItem className="font-medium mb-2 "
						name="cte_name"
						label="Team Name"
						rules={mode !== "view" && [requiredField]}
						
					>
						<Input id="cte_name"
							placeholder="Enter team name..."
							className="input-field" 
							maxLength={30}
						/>
					</FormItem>
				</div>
				<div className="col-span-1">
					<FormItem
							label="Department"
							name="cte_department_id"
							rules={[requiredField]}
						>
							<Select id="cte_department_id"
								className="input-field"
								showSearch
								allowClear={true}
								options={recordData?.departmentList}
							/>
						</FormItem>
				</div>
			</div>
			<div className="grid grid-cols-1 md:grid-cols-3 gap-y-2 gap-x-4 w-full">
				<div className="col-span-2">
					<FormItem className="font-medium mb-4 "
						label="Head of Department"
						name="supervisors"
						// rules={mode !== "view" && (!addUserFilled ? [requiredField] : [])}
					>
						{mode !== "view" ?
							<Select id="supervisors"
								className="input-field"
								showSearch
								allowClear={true}
								placeholder="Select department head"
								optionFilterProp="label"
								onChange={value => setSupervisorSelected(!!value && value.length > 0)}
								maxTagCount="responsive"
								style={{ width: "100%"}}
								options={recordData?.supervisorOptionList}
							/>
							: 
							<div >
								<List
									className="text-base label-value dark:text-white"
									dataSource={recordData?.supervisors}
									renderItem={item => (
										<List.Item
											actions={[
												<UnassignButton
													key="unassign"
													supervisorItem={item}
													form={form}
													setSupervisors={setSupervisors}
													setSupervisorSelected={setSupervisorSelected}
													unassignHandler={() =>
														doUnassign({
															cte_client_id: clientId,
															cte_id: recordId,
															cts_id: item?.cts_id,
														})
													}
												/>,
											]}
										>
											{item.supervisor.name}
										</List.Item>
									)}
								>
								</List>
							</div>
						}
					</FormItem>	  
				</div>
				<div className="col-span-1">
					<FormItem className="font-medium mb-2 "
						name="cte_location"
						label="Location"
					>
						<Input id="cte_location"
							placeholder="Office location"
							className="input-field" 
							maxLength={30}
						/>
					</FormItem>
				</div>
			</div>
			
				{!supervisorSelected && mode !== "view" && (
					<div className="w-full">
						<Button
							type="dashed"
							block
							onClick={toggleAddUser}
							className="
								flex items-center justify-between
								bg-gray-100 dark:bg-gray-100/20
								dark:hover:!bg-gray-200/50
								muted-text
							"
						>
							<span className="flex items-center gap-4">
								<span>{addUserOpen ? <DownOutlined /> : <PlusOutlined />}</span>
								<span className="font-medium"> Add User</span>
							</span>
						</Button>

						<div
							className={`
								grid transition-all duration-200 ease-in-out
								${addUserOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}
							`}
						>
							<div className="overflow-hidden">
								<div className="pt-3 form-column-2">
									<Space.Compact className="font-medium gap-2 w-full">
										<FormItem
											label="First Name"
											name="ude_first_name"
											rules={addUserValidation ? [requiredField] : undefined}
											className="mb-0 w-1/2"
										>
											<Input
												id="ude_first_name"
												placeholder="First Name"
												className="input-field"
												maxLength={50}
											/>
										</FormItem>

										<FormItem
											label="Last Name"
											name="ude_last_name"
											rules={addUserValidation ? [requiredField] : undefined}
											className="mb-0 w-1/2"
										>
											<Input
												id="ude_last_name"
												placeholder="Last Name"
												className="input-field"
												maxLength={50}
											/>
										</FormItem>
									</Space.Compact>

									<FormItem
										label="Email"
										name="email"
										rules={addUserValidation ? [requiredField, emailField] : undefined}
									>
										<Input
											id="email"
											placeholder="username@domain.com"
											className="input-field"
											maxLength={50}
										/>
									</FormItem>

									<FormItem
										label="Role / Job Title"
										name="clu_job_title"
									>
										<Input
											id="clu_job_title"
											className="input-field"
											maxLength={50}
										/>
									</FormItem>
								</div>
							</div>
						</div>
					</div>
				)}
			<div className="form-column-2">  		            	            
				<div className="col-span-2 mt-2">
					<FormItem className="font-medium mb-2 "
						name="cte_description"
						label="Description"						
					>
						<TextArea id="cte_description"
							placeholder="Describe the departments's role and responsibilities"
							className="input-field" 
							maxLength={225}
						/>
					</FormItem>
				</div>
				{/* <div className="col-span-1">
					<FormItem className="font-medium mb-2 "
						name="cte_annual_budget"
						label="Annual Budget"						
					>
						<InputNumber id="cte_annual_budget" 
							precision={2}
							min={1}
							placeholder="0.00"
							className="input-field mt-4"
						/>
					</FormItem>
				</div> */}
			</div>
			<div className="bg-slate-200 shrink-0 h-px w-full my-2"></div>
			<div className="w-full flex justify-end dark:">
				{(mode === "edit") && (
					<CrudButtons
						mode={mode}
						recordId={recordData?.cte_id ?? 0}
						isModal={true}
						modalId={recordData?.cte_id > 0 ? `edit_client_team_${recordId}` : 'add_client_team'}
						cancelLabel="Cancel"
						doHideModal={onCancel}
						submitLabel="Save"
						moduleId={MODULE_CLIENT}
					/>
				)}
			</div>
		</Form>	 	
  	);
};

export default ClientTeamForm;
